import {Injectable} from '@angular/core';
import {Meta} from './meta';
import {MetaPropertyNotDefined} from '../../decorator/error/meta-property-not-defined.error';

@Injectable({
  providedIn: 'root'
})
export class EntityManagerMetaDataService {

  public createMetaData(instance: any): EntityManagerMetaDataService {
    instance.constructor[Meta.META] = instance.constructor[Meta.META] || {};

    return this;
  }

  public hasMetaData(instance: any): boolean {
    return instance.constructor[Meta.META];
  }

  public hasMetaDataProperty(instance: any, metaProperty: string): boolean {
    if (!this.hasMetaData(instance)) {
      console.error(`No meta data for instance ${instance}`);
    }

    return this.isValueNotEmpty(instance.constructor[Meta.META][metaProperty]);
  }

  public getMetaDataProperty(instance: any, metaProperty: string): any {

    if (!this.hasMetaDataProperty(instance, metaProperty)) {
      throw new MetaPropertyNotDefined(instance, metaProperty);
    }

    return instance.constructor[Meta.META][metaProperty];
  }

  public setMetaDataProperty(instance: any, metaProperty: string, value: any): this {

    if (!this.hasMetaData(instance)) {
      console.error(`No meta data for instance ${instance}`);
    }

    instance.constructor[Meta.META][metaProperty] = value;

    return this;
  }

  public getMetaData(instance: any, metaProperty: string) {
    return instance.constructor[Meta.META][metaProperty];
  }

  private isValueNotEmpty(value: any): boolean {
    return typeof value !== 'undefined' && value !== null && value !== '';
  }

  public getAssociation(instance: any, propertyKey: string): typeof Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS][propertyKey];
  }

  public getAssociations(instance: any): Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS];
  }

  public getAssociationsMany(instance: any): Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY];
  }

  public getAssociationMany(instance: any, propertyKey: string): typeof Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY][propertyKey];
  }

  public getAssociationsManyToMany(instance: any): Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY];
  }

  public getAssociationManyToMany(instance: any, propertyKey: string): typeof Object {
    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY][propertyKey];
  }

  public getPropertyPayloadModifiers(instance: any): Object {
    return instance.constructor[Meta.META][Meta.META_PROPERTY_PAYLOAD_MODIFIER];
  }

  public getPropertyResponseModifiers(instance: any): Object {
    return instance.constructor[Meta.META][Meta.META_PROPERTY_RESPONSE_MODIFIER];
  }

  public hasAssociation(instance: any, propertyKey: string): boolean {
    if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS)) {
      return false;
    }

    return typeof instance.constructor[Meta.META][Meta.META_ASSOCIATIONS][propertyKey] !== 'undefined';
  }

  public hasAssociationMany(instance: any, propertyKey: string) {

    if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS_MANY)) {
      return false;
    }

    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY][propertyKey];
  }

  public hasAssociationManyToMany(instance: any, propertyKey: string) {

    if (!this.hasMetaDataProperty(instance, Meta.META_ASSOCIATIONS_MANY_TO_MANY)) {
      return false;
    }

    return instance.constructor[Meta.META][Meta.META_ASSOCIATIONS_MANY_TO_MANY][propertyKey];
  }
}
